import { useDataStore } from "@/stores";
import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";
import { useMemo } from "react";

type SoftwareDropdownProps = {
    selectedVersions: string[];
    loading: boolean;
    value: Array<string>;
    onChange: (event: SelectChangeEvent<Array<string>>) => void;
};

const DownloadSoftwareDropdown = ({ selectedVersions, value, loading, onChange }: SoftwareDropdownProps) => {
    const software = useDataStore((state) => state.software);

    const items = useMemo(() => {
        const commonSoftware = selectedVersions.length
            ? [
                  ...selectedVersions
                      .map((versionId) => software[versionId] || [])
                      .reduce((a, b) => a.filter((c) => b.some((d) => d.id === c.id))),
              ]
            : [];

        if (commonSoftware.find((x) => x.name !== "IDS")) {
            commonSoftware.push({
                id: "00000000-0000-0000-0000-000000000000",
                name: "IDS",
                active: true,
                bimQLabel: "IDS",
                version: "DEFAULT",
                order: 999,
                isIfc: false,
                defaultActive: false,
                icon: "",
            });
        }

        return commonSoftware.filter((x) => x.active);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVersions, loading, software]);

    return (
        <FormControl fullWidth size={"medium"} id={"medium"}>
            <InputLabel id="software-dropdown-label">Software</InputLabel>
            <Select
                labelId="software-dropdown-label"
                id="software-dropdown"
                value={value}
                onChange={onChange}
                input={<OutlinedInput label={"Software"} />}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 48 * 4.5 + 8,
                        },
                    },
                }}
                fullWidth
                multiple
            >
                {loading ? (
                    <MenuItem value={""}>Loading...</MenuItem>
                ) : (
                    items.map((x) => (
                        <MenuItem key={x.id} value={x.id}>
                            {x.name ?? x.bimQLabel}
                        </MenuItem>
                    ))
                )}
            </Select>
        </FormControl>
    );
};

export default DownloadSoftwareDropdown;
